import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { IPopup } from '@context/global/typescript';
import { useResponsive } from '@features/responsive';
import MessageMobile from '@components/Message/MessageMobile';
import Message from '@components/Message/Message';
import theme from '@styles/theme';
import popupStore from '@context/global/mobx/popupStore';
import styles from '@components/Popups/Popups.styles';
type PropsType = {
  popup: IPopup;
};
const Popup = ({
  popup
}: PropsType) => {
  const [isActive, setIsActive] = useState(false);
  const {
    isNarrowerThanMobilelg
  } = useResponsive();
  const {
    message,
    type,
    id,
    displayTime,
    attachRefresh
  } = popup;
  const router = useRouter();
  const animationTime = 300;
  let backgroundColor = theme.rawColors.dirtyPink200;
  switch (type) {
    case 'success':
      backgroundColor = theme.rawColors.green100;
      break;
    case 'error':
      backgroundColor = theme.rawColors.dirtyPink200;
      break;
    case 'warning':
      backgroundColor = theme.rawColors.saffron300;
      break;
    case 'info':
      backgroundColor = theme.rawColors.dirtyBlue300;
      break;
    default:
      break;
  }
  const closeAndRemovePopup = () => {
    setIsActive(false);
    setTimeout(() => {
      popupStore.removePopup(id);
    }, 2 * animationTime);
  };
  useEffect(() => {
    let displayTimeout: NodeJS.Timeout | null = null;
    setTimeout(() => {
      setIsActive(true);
    }, animationTime);
    if (displayTime) {
      displayTimeout = setTimeout(() => {
        closeAndRemovePopup();
      }, displayTime);
    }
    router.events.on('routeChangeStart', closeAndRemovePopup);
    return () => {
      if (displayTimeout) {
        clearTimeout(displayTimeout);
      }
      router.events.off('routeChangeStart', closeAndRemovePopup);
    };
  }, [router, displayTime, id]);
  return <div sx={styles.popup(isActive)}>
      {isNarrowerThanMobilelg ? <MessageMobile message={message} onClose={closeAndRemovePopup} backgroundColor={backgroundColor} displayBarTime={displayTime} isOnCloseAnimation={false} attachRefreshLink={attachRefresh} /> : <Message marginTop={24} message={message} marginBottom={0} onClose={closeAndRemovePopup} backgroundColor={backgroundColor} displayBarTime={displayTime} isOnCloseAnimation={false} attachRefreshLink={attachRefresh} />}
    </div>;
};
export default observer(Popup);